import { Component, Input, inject } from '@angular/core';
import { LoggerService } from '../../services/logger.service';

@Component({
    standalone: false,
    selector: 'por-admin-demo',
    templateUrl: './admin-demo.component.html',
    styleUrls: ['./admin-demo.component.scss']
})
export class AdminDemoComponent {
    private readonly logger = inject(LoggerService);

    @Input() url = '';
    @Input() config = '';

    handleOutPutError($e: any) {
        this.logger.logInfo({
            $e
        });
    }
}
